///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const NotificationIcon = ({ title = messages.notifications.defaultMessage, ...rest }) => (
  <svg
    aria-labelledby="notification-icon"
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title data-testid="notification-icon">{title}</title>
    <defs>
      <path
        d="M10 18.333c.917 0 1.667-.75 1.667-1.666H8.333c0 .916.75 1.666 1.667 1.666zm5-5V9.167c0-2.559-1.358-4.7-3.75-5.267v-.567c0-.691-.558-1.25-1.25-1.25s-1.25.559-1.25 1.25V3.9C6.367 4.467 5 6.6 5 9.167v4.166L3.333 15v.833h13.334V15L15 13.333zm-1.667.834H6.667v-5c0-2.067 1.258-3.75 3.333-3.75s3.333 1.683 3.333 3.75v5z"
        id="notification-icon-path"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <mask id="notification-icon-mask" fill="#fff">
        <use xlinkHref="#notification-icon-path" />
      </mask>
      <use fill="#000" xlinkHref="#notification-icon-path" />
      <g mask="url(#notification-icon-mask)" fill="#FFF">
        <path d="M0 0h20v20H0z" />
      </g>
    </g>
  </svg>
);

export default NotificationIcon;
